<script>
import resources from './resources'

export default {
  name: 'gadget-agenda-statistics',

  mixins: [resources]
}
</script>

<template lang="pug">
  div
    section.gadget-agenda-estatisticas.wrapper.full-width.gadget.m-b-20(v-if="!ishidden")
    section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget(v-if="ishidden")
      .gadget-title
        | Estatísticas das Agendas
      .actions
        span.icon 
        ul
          li.exclude Remover
          li.half-width Lado a Lado
          li.full-width Tela Inteira
      div(v-for="agenda in agendas", :key="agenda.id", v-if="agenda.validate === lastday")
        .col-xs-12.col-sm-2.col-md-4
          label.light-red Agenda
          h4.medium-gray {{ agenda.name }}
        .col-xs-12.col-sm-2.col-md-2
          label.light-red Validade
          h4.medium-gray {{ agenda.validate }}
        .col-xs-12.col-sm-2.col-md-2
          label.light-red Regras
          h4.medium-gray {{ agenda.total_rules }}
        .col-xs-12.col-sm-2.col-md-2
          label.light-red Eventos Disponíveis
          h4.medium-gray {{ agenda.total_available }}
        .col-xs-12.col-sm-2.col-md-2
          label.light-red Situação da Agenda
          .percentage-graph
            // Base
            .base
              .text {{ agenda.percentage_used }}% Preenchida
            // Cor
            .color(:style="'width:' + agenda.percentage_used + '%;'")
              .text
                | {{ agenda.percentage_used }}% Preenchida
        .clearfix
</template>
<style scoped>
  .m-b-20 {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/components/agendas-statistics/agenda-statistics.vue